$(document).ready(function(){
  
  
 
  $("li.bazar").click(function(){
    $("p.bazar").css("display", "block");
    $("p.house_keeping").css("display", "none");
    $("p.vouge").css("display", "none");
    $("p.vulcan_post").css("display", "none");

    $("li.bazar a svg").css("opacity","1");
    $("li.house_keeping a svg").css("opacity","0.2");
    $("li.vouge a svg").css("opacity","0.2");
    $("li.vulcan_post a svg").css("opacity","0.2");
  }); 
  $("li.house_keeping").click(function(){
    $("p.bazar").css("display", "none");
    $("p.house_keeping").css("display", "block");
    $("p.vouge").css("display", "none");
    $("p.vulcan_post").css("display", "none");

    $("li.bazar a svg").css("opacity","0.2");
    $("li.house_keeping a svg").css("opacity","1");
    $("li.vouge a svg").css("opacity","0.2");
    $("li.vulcan_post a svg").css("opacity","0.2");
  }); 

  $("li.vouge").click(function(){
    $("p.bazar").css("display", "none");
    $("p.house_keeping").css("display", "none");
    $("p.vouge").css("display", "block");
    $("p.vulcan_post").css("display", "none");

    $("li.bazar a svg").css("opacity","0.2");
    $("li.house_keeping a svg").css("opacity","0.2");
    $("li.vouge a svg").css("opacity","1");
    $("li.vulcan_post a svg").css("opacity","0.2");
  }); 
  $("li.vulcan_post").click(function(){
    $("p.bazar").css("display", "none");
    $("p.house_keeping").css("display", "none");
    $("p.vouge").css("display", "none");
    $("p.vulcan_post").css("display", "block");

    $("li.bazar a svg").css("opacity","0.2");
    $("li.house_keeping a svg").css("opacity","0.2");
    $("li.vouge a svg").css("opacity","0.2");
    $("li.vulcan_post a svg").css("opacity","1");
  }); 

  /********************* Header Fixed on All********************/
  $(window).scroll(function() {    
    var scroll_val = $(".cst-header-sec-main").scrollTop();    
    if($(window).scrollTop() > scroll_val+31){
      $("#shopify-section-header").addClass("header-fixed");
      $(".ans-cst-cart").addClass("ans-cst-cart-fixed");
    }
    else{
      $("#shopify-section-header").removeClass("header-fixed");
      $(".ans-cst-cart").removeClass("ans-cst-cart-fixed");
    }

    /******************* Cart page right section block*************/
    if($(window).scrollTop() > 300){
      $(".cart_content_container").addClass("cart-cont-rt-fixed");
    }
    else{
      $(".cart_content_container").removeClass("cart-cont-rt-fixed");
    }
  })
  /******************* Cart Slide Cart on All*************/
  $('.header-cart-related-list').slick({
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1
  }); 

  /********************Fotter Accordion on All***********************/
  $( function() {
    $("#footer-accordion" ).accordion({
      collapsible: true,heightStyle: "content"
    });
  });

  $( function() {
    $(".accordion-child" ).accordion({
      collapsible: true, heightStyle: "content"
    });
  });
  /*********************Currency Convertor on All**********************/
  $(".custom_currency_wrapper").click(function(){
    $("#custom-currency-list").slideToggle(100); 
  })

  $("#custom-currency-list li").click(function(){
    var custom_currency = $(this).html();
    $(".custom-currency-drop").html(custom_currency);
    $("#currency-list .disclosure-list__item").each(function(){
      var actual_currency_list = $(this).children("a").attr("data-value");
      if(custom_currency==actual_currency_list){
        $(this).trigger("click");
      }
    })
  })

  /*****************Mobile Header on All***********************/
  $(".cst-mob-header-menu-toggle").click(function(){
    $(this).toggleClass("custom-mobile-close");
    $(".cst-mob-header").toggleClass("show-mobile-menu");
    $("body").toggleClass("for-custom-mobile-menu");
    /* changes - toggle hidden reward & chat widget */
    $("#admin-bar-iframe").toggleClass("hide");
    $("#chat-button").toggleClass("hide");
  })

  $(".mobile-accordion-list").click(function(){

    if($(this).hasClass("custom-open-accordion")){
      $(this).removeClass("custom-open-accordion");
    }
    else{
      $(this).addClass("custom-open-accordion");
      $(this).siblings("li").removeClass("custom-open-accordion");
    }
  })
  $(".tab-listing").click(function(){

    $(this).addClass("active-tab");
    $(this).siblings("li").removeClass("active-tab");

    var data_tab = $(this).attr("data-tab");
    $(".cst-mob-header-dd-tab-cont").each(function(){
      var data_content = $(this).attr("data-content");
      if(data_content==data_tab){
        $(this).show();
        $(this).siblings(".cst-mob-header-dd-tab-cont").hide();
      }
    })
  })
  /*******************Top bar close for Mobile on All*****************/
  $(".ext-top-bar-left-inn-close").click(function(){
    $(".ext-top-bar").addClass("close-top-bar");
  })

  /************************ Search Open on Icon Click on All*****************/
  $(".custom-search").click(function(){
    $(".boost-pfs-search-suggestion-mobile-top-panel").css("display", "block");/*FS add*/
    
  })
  $(".btn--link.search-bar__close.js-drawer-close").click(function(){
    $("html").removeClass("js-drawer-open js-drawer-open-top");
    $("body").removeClass("js-drawer-open js-drawer-open-top prevent-scrolling");
  })
 

  /************ Top Bar Slider on All *********************/
  if ($(window).width() < 749) {
    $('.hm-fav-product-listing-main').slick({
      dots: false,
      prevArrow: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: false
    });
  }
  if ($(window).width() < 750) {
    $('.logo-slider-mobile').slick({
      dots: true,
      prevArrow: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: false
    });
    // Run when slides change
    $('.logo-slider-mobile').on('afterChange', function(event, slick, currentSlide) {
      if(currentSlide == 0){
        $("li.bazar").trigger( "click" );
      }
      else if(currentSlide == 1){
        $("li.house_keeping").trigger( "click" );
      }
      else if(currentSlide == 2){
        $("li.vouge").trigger( "click" );
      }
      else if(currentSlide == 3){
        $("li.vulcan_post").trigger( "click" );
      }
    });
  }
  else if($(window).width() < 1200)  {
    $('.logo-slider-mobile').slick({
      dots: true,
      prevArrow: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: false
    });
    // Run when slides change
    $('.logo-slider-mobile').on('afterChange', function(event, slick, currentSlide) {
      if(currentSlide == 0){
        $("li.bazar").trigger( "click" );
      }
      else if(currentSlide == 1){
        $("li.house_keeping").trigger( "click" );
      }
      else if(currentSlide == 2){
        $("li.vouge").trigger( "click" );
      }
      else if(currentSlide == 3){
        $("li.vulcan_post").trigger( "click" );
      }
    });

  }



  /************************************************************/
  /************************bs-script.js start******************/
  /************************************************************/
  //socialLogin.loginPopup();

  /****************cookie banner*********************/
  $(function(){
    var check_privacy = $.cookie('bs-privacy_3_30');
    //check_privacy = null;/*Test*/
    if(check_privacy == null)
    {
      $(".bs-cookie-banner").show();//Right now Hide
    }
  });

  $(".bs-cookie-banner .bs-cookie-banner-accept").on("click",function(e){
    e.preventDefault();
    $(".bs-cookie-banner").hide();
    $.cookie('bs-privacy_3_30', "done" , { expires: 7 });
  });

  /****************faq page********************/
  $(function() {
  	var $accordion = $(".bs-faq-main-accor").accordion({active: false,heightStyle: "content", collapsible: true}),
      hashId = 0;

    if (window.location.hash) {
      $accordion.children('h4').each(function(i){
        var faqId = $(this).attr("id").replace("tab-","");
        //this.id = faqId;
        if (faqId === window.location.hash.slice(1)) {
          hashId = i;
        }
      });
      
      $accordion.on( "accordionactivate", function( event, ui ) {
      if(hashId != 0)
          {
            diff = $(".cst-header-sec").outerHeight();
            if($(".cst-mob-header").is(":visible"))
            {
              diff = $(".cst-mob-header").outerHeight();
            }
            $("html,body").animate({scrollTop:$(".bs-faq-accor-head.ui-state-active").offset().top - diff - 20},500);
          }
      } );

      $accordion.accordion({
        active: hashId,
        collapsible: true,
        heightStyle: "content",
        header: ".bs-acct-order-accor-head",
        animate: 0,
        create: function( event, ui ) {
          $accordion.children('h4').each(function(i){
//             $(this).before('<a class="bs-faq-main-accor" data-index="' + i + '" href="#' + faqId + '"></a>');
          });
          $accordion.find('.bs-faq-main-accor').click(function(){
            $accordion.accordion( "option", "active", $(this).data('index') );
          });
          
        }
    });
  }
 });

  /********************account mobile nav*********************/
  
  $(document).on('touchstart', '.bs-acct-mob-list-btn', function(){
    $(this).toggleClass('EnableAcctMobNav');
    if ($(this).hasClass("EnableAcctMobNav")) {
      $(this).siblings('.bs-acct-mob-list-block').show();
    } else{
      $(this).siblings('.bs-acct-mob-list-block').hide();
    }
  });

  var location = (window.location.pathname);
  if(location=="/account")
  {
    $(".bs-acct-details-right").show();
    $(".bs-acct-order-list-right").hide();
    
    /*
    $(".AccountForm").show();
    $(".OrderHis").hide();
    $(".tlt-account-main-head h1").html("Profile Settings");
    $(".CustomerSidebar li").each(function(){
      var linkget = $(this).children("a").attr("href");
      if(linkget==location){
        $(this).addClass("active");
      }
    })*/
  }
  else if(location=="/account/")
  {
    $(".bs-acct-details-right").hide();
    $(".bs-acct-order-list-right").show();

    /*
    $(".AccountForm").hide();
    $(".OrderHis").show();
    $(".tlt-account-main-head h1").html("Order History");
    $(".CustomerSidebar li").each(function(){
      var linkget = $(this).children("a").attr("href");
      if(linkget==location){
        $(this).addClass("active");
      }
    })*/
  }
  else
  {
    /*
    $(".CustomerSidebar li").each(function(){
      var linkget = $(this).children("a").attr("href");
      if(linkget==location){
        $(this).addClass("active");
      }
    })*/
  }

  $(".bs-acct-order-list-accor" ).accordion({
    collapsible: true,
    heightStyle: "content",
    header: ".bs-acct-order-accor-head", 
    active: false, 
    animate: 0
  });
  /*****************blog loadmore*****************************/

  $("#bs-blog-load-btn").on("click",function(e){
    e.preventDefault();
    var page_url = "/blogs/news?page=";
    var page_total =  parseInt($("#bs-art-pg-total").val());
    var page_cur =  parseInt($("#bs-art-pg-cur").val());
    if(page_cur < page_total)
    {
      page_url = page_url + (page_cur + 1);
      $.ajax({
        type: 		'GET',
        dataType: 	'html',
        url: 		page_url,     
        success: function(data) {
          let filteredData = $(data).find(".bs-blog-row");
          $(filteredData).appendTo($(".bs-blog-row").parent());
          $("#bs-art-pg-cur").val(page_cur + 1);
          if(page_cur + 1 >= page_total)
          {
            $("#bs-blog-load-btn").hide();
          }
        }
      });
    }
  });
  /**********product page review*****************/
  $(".stamped-main-badge").on("click",function(e){
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".sin-pro-review-sec").offset().top
    }, 100);
  });
  $(".custom-review-product").on("click",function(e){
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".sin-pro-review-sec").offset().top - $(".product-floating-atc").outerHeight()
    }, 100);
  });
  
  /************************************************************/
  /************************bs-script.js End*************************/
  /************************************************************/
}) 